import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "toolbox"
};
const _hoisted_2 = {
  class: "wrapper"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "业务员名称", -1);

const _hoisted_4 = {
  class: "wrapper"
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "专职/兼职", -1);

const _hoisted_6 = {
  class: "wrapper"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定");

import { ref, computed, watch } from 'vue';
import { getVexTableProps } from '@/config';
import { ElMessageBox, ElMessage } from 'element-plus';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'user-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supplierId: [String, Number],
    selectedList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emits('update:modelValue', val);
      }

    });
    watch(() => props.modelValue, v => {
      if (v) {
        search.value = {
          linkMan: '',
          salesmanType: ''
        };
        selectedList.value = [...props.selectedList]; // table.value.commitProxy('reload')
      }
    });
    const search = ref({
      linkMan: '',
      salesmanType: ''
    });
    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '业务员名称',
        field: 'linkMan'
      }, {
        title: '用户名',
        field: 'linkMan'
      }, {
        title: '团队名称',
        field: 'supplierName'
      }, {
        title: '身份',
        field: 'employeeTypeName'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(resolve => {
            let params = _objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize,
              supplierId: props.supplierId
            }, search.value);

            Axios.get('/admin/split/rule/supplierSalesmanList.json', {
              params
            }).then(res => {
              let {
                success,
                data
              } = res.data;

              if (success) {
                resolve({
                  total: data.total,
                  result: data.list
                });

                if (selectedList.value.length) {
                  setTimeout(() => {
                    let selectedRows = data.list.filter(item => selectedList.value.find(v => v.supUserId == item.supUserId));
                    table.value.setCheckboxRow(selectedRows, true);
                  }, 300);
                }
              }
            });
          })
        }
      }
    });

    function reset() {
      search.value = {
        linkMan: '',
        salesmanType: ''
      };
      table.value.commitProxy('reload');
    }

    const selectedList = ref([]);

    function tableSelectHandle(e) {
      let {
        row,
        checked
      } = e;
      let findIndex = selectedList.value.findIndex(v => v.supUserId == row.supUserId);

      if (checked && findIndex == -1) {
        selectedList.value.push(row);
      } else {
        selectedList.value.splice(findIndex, 1);
      }
    }

    function tableAllSelectHandle(e) {
      let {
        records,
        checked
      } = e;

      if (checked) {
        records.forEach(item => {
          if (selectedList.value.find(v => v.supUserId == item.supUserId)) return;
          selectedList.value.push(item);
        });
      } else {
        tableData.value.forEach(item => {
          let findIndex = selectedList.value.findIndex(v => v.supUserId === item.supUserId);

          if (findIndex > -1) {
            selectedList.value.splice(findIndex, 1);
          }
        });
      }
    }

    function submit() {
      // if (selectedList.value.length) {
      //     emits('success', selectedList.value)
      // }
      if (selectedList.value.length === 0) {
        ElMessage.error('请选择人员');
        return;
      }

      let supUserIds = selectedList.value.map(v => v.supUserId).join();
      let url = `/admin/split/rule/insertOrDeleteSplitBlacklist.json?supplierId=${props.supplierId}&supUserIds=${supUserIds}&type=1`;
      Axios.post(url).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('操作成功');
          emits('success');
          visible.value = false;
        } else {
          ElMessage.error(msg);
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "人员列表",
        width: "900px",
        top: "5vh",
        "custom-class": "setting-user-modal"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, null, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_input, {
          modelValue: search.value.linkMan,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.value.linkMan = $event),
          placeholder: "请输入业务员名称"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_select, {
          modelValue: search.value.salesmanType,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => search.value.salesmanType = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "全部",
            value: ""
          }), _createVNode(_component_el_option, {
            label: "专职",
            value: "1"
          }), _createVNode(_component_el_option, {
            label: "兼职",
            value: "2"
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        })])]), _unref(visible) ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
          key: 0,
          ref_key: "table",
          ref: table
        }, _unref(tableOptions), {
          onCheckboxChange: tableSelectHandle,
          onCheckboxAll: tableAllSelectHandle
        }), null, 16)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};